import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { NoResultsIcon } from '@rsos/assets/icons';
import { Box } from '@rsos/components/capstone/base';
import type { RootState } from '../../../app/rootReducer';
import { MAF_ERROR_REQUEST_FAILED } from '../constants';
import {
  ErrorText,
  ErrorTextCritical,
  NoResultText,
  IconWrapper,
} from './ConnectedUniversalSearch.styles';
import type { ErrorWrapperProps } from './ConnectedUniversalSearch.types';

export function ErrorWrapper({
  isValidW3W,
  mafError = null,
}: ErrorWrapperProps) {
  const searchTerm = useSelector(
    (state: RootState) => state.search?.searchTerm || '',
  );
  const isRequestFailed = mafError === MAF_ERROR_REQUEST_FAILED;

  const cleanSearchTerm = useMemo(() => {
    /**
     * @constant splittedStr {Array} - splitting the searchTerm by forward slash and space
     * the searchTerms are first formatted from connectedUniversalSearch
     * "/// new.york.food" -> "new.york.food"
     * "/maf 6664444" -> "6664444"
     * "/ 12223334444" -> "12223334444"
     */
    if (searchTerm) {
      const splittedStr = searchTerm.split(/([/\s])/); // forward slash and space
      return splittedStr[splittedStr.length - 1];
    }
    return searchTerm;
  }, [searchTerm]);

  return (
    <Box px={3} pb={3} pt={2}>
      <Box horizontal align="center" py={2}>
        <IconWrapper>
          <NoResultsIcon />
        </IconWrapper>
        {isRequestFailed ? (
          <ErrorTextCritical>
            Search Failed. Please try again.
          </ErrorTextCritical>
        ) : (
          <NoResultText>No Results</NoResultText>
        )}
      </Box>

      {!isRequestFailed &&
        (!isValidW3W ? (
          <ErrorText>
            Please make sure that name or number is spelled correctly.
          </ErrorText>
        ) : (
          <ErrorText>0 Results found for {cleanSearchTerm}.</ErrorText>
        ))}
    </Box>
  );
}
